export function setChangeStatus(data) {
    return {
      type: 'SET_CHANGE_STATUS',
      payload: data,
    }
}